<template>
  <div class="side">
    <div class="top">
      <img
        class="logo"
        :src="originUrl"
        :style="
          origin === 'heyboxacc' || origin === 'heybox' ? 'height: 30px' : ''
        "
      />
    </div>
    <div class="bottom">
      <div class="slider">
        <div class="side-swiper" ref="mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide slider-item">
              <div class="t1">小黑盒<br />高能玩家聚集地</div>
              <div class="t2">HEY BOX HEY GAMERS</div>
            </div>
            <div class="swiper-slide slider-item">
              <div class="t1">众力探索<br />未知游戏世界</div>
              <div class="t2">Explore the unknown game world together</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-outer">
        <div
          :class="isActive === index ? 'pagination' : 'pagination grey'"
          v-for="(item, index) in 2"
          :key="index"
          @click="changeSwiper(index)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default {
  props: {
    origin: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      originUrl: '',
      isActive: 0,
    };
  },
  created() {
    this.parseUrlQuery();
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    parseUrlQuery() {
      if (this.origin === 'workshop') {
        this.originUrl =
          'https://cdn.max-c.com/heybox/dailynews/img/8e96b9deace326bd50b49d42b614d4fe.png';
      } else if (this.origin === 'heybox') {
        this.originUrl =
          'https://imgheybox.max-c.com/oa/2023/02/08/8d7746984d5a90b1c6ae4cf8ee0db273.svgz';
      } else if (this.origin === 'heyboxacc') {
        this.originUrl =
          'https://cdn.max-c.com/acc_baike/assets/version_1_0_4/images/logo@2x.png';
      } else if (this.origin === 'oa') {
        this.originUrl =
          'https://imgheybox.max-c.com/oa/2023/02/08/a5752ca5f5cef272f93db121a896455c.svgz';
      }
    },
    initSwiper() {
      const _this = this;
      this.swiper = new Swiper('.side-swiper', {
        //自动轮播
        autoplay: {
          delay: 1000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: false,
        speed: 400,
        on: {
          activeIndexChange: (swiper) => {
            _this.isActive = swiper.activeIndex;
          },
        },
      });
    },
    changeSwiper(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>
<style lang="less">
.side {
  display: flex;
  flex-direction: column;
  width: 38.2%;
  .top {
    position: relative;
    flex: 1;
    background: #1c1c1e
      url('https://imgheybox.max-c.com/oa/2023/02/08/4591b1635700c5aa1bc143d76bd50c4e.svgz')
      center/cover;
    .logo {
      position: absolute;
      top: 40px;
      left: 40px;
      height: 20px;
    }
  }
  .bottom {
    height: calc(50% - 140px);
    background: #18181a;
    color: #ffffff;
    padding: 20px 20px 30px 20px;
    .slider {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .side-swiper {
        width: 100%;
        height: 100%;
      }
      .slider-item {
        text-align: left;
        color: #e0e0e0;
        .t1 {
          font-size: 20px;
          font-weight: 600;
          line-height: 36px;
          margin-bottom: 8px;
        }
        .t2 {
          font-size: 18px;
          font-weight: 300;
          line-height: 25px;
        }
      }
    }
    .pagination-outer {
      display: flex;
      .pagination {
        height: 4px;
        width: 30px;
        background: #ffffff;
        &.grey {
          opacity: 0.1;
          background-color: #ffffff;
        }
      }
    }
  }
}
</style>
